// extracted by mini-css-extract-plugin
export default {"button":"ContactButton_button__KHkcb","buttonText":"ContactButton_buttonText__0b6uO"};